import { useEffect, useState } from 'react'

import Api from 'services/api'
import { OracleAccountInfo } from 'types/OracleAccountInfo'

const useOracleAccount = (isDso: boolean, dealerId?: string) => {
  const [oracleAccount, setOracleAccount] = useState<OracleAccountInfo | null>(null)
  const [isOracleAccountLoaded, setIsOracleAccountLoaded] = useState(false)

  useEffect(() => {
    if (!isDso || !dealerId) {
      setIsOracleAccountLoaded(true)
      return
    }

    if (isDso && dealerId) {
      setIsOracleAccountLoaded(false)
      Api.Paywall.getOracleAccountInfo(Number(dealerId))
        .then((res) => {
          setOracleAccount(res)
          setIsOracleAccountLoaded(true)
        })
        .catch(() => {
          setIsOracleAccountLoaded(true)
        })
    }
  }, [isDso, dealerId])

  return { oracleAccount, isOracleAccountLoaded }
}

export default useOracleAccount
